import { Icon } from '@/components/ui/Icon'
import styles from './Info.module.scss'

type InfoVariant = 'primary' | 'success' | 'warning' | 'error'

interface InfoProps {
  children: string
  variant?: InfoVariant
  testId?: string
}

const iconNameMap: Record<InfoVariant, string> = {
  primary: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
}

const iconColorMap: Record<InfoVariant, string> = {
  primary: '#0261ad',
  success: '#22c55e',
  warning: '#f97316',
  error: '#ef4444',
}

export const Info = ({ children, variant = 'primary', testId }: InfoProps) => {
  const classNames = [styles.info, styles[variant]].join(' ')

  return (
    <div className={classNames} data-testid={testId}>
      <Icon
        name={iconNameMap[variant]}
        color={iconColorMap[variant]}
        className={styles.icon}
      />
      <p className={styles.text}>{children}</p>
    </div>
  )
}
